import React from "react";

export const STEPS = [
  { id: "plan", n: 1, label: "Plan", desc: "Agenda & Attendees" },
  { id: "prepare", n: 2, label: "Prepare", desc: "AI Mapping & Questions" },
  { id: "record", n: 3, label: "Record", desc: "Live Room & Quality" },
  { id: "review", n: 4, label: "Review", desc: "Audio & Transcript" },
  { id: "clarify", n: 5, label: "Clarify", desc: "AI Analysis & Gaps" },
  { id: "generate", n: 6, label: "Generate", desc: "Branded Deliverables" },
  { id: "track", n: 7, label: "Track", desc: "PM Hub & RAID" },
];

export default function Stepper({ active, done = [], onSelect }) {
  return (
    <div className="flex items-center overflow-x-auto no-scrollbar py-1" data-testid="stepper">
      {STEPS.map((s, i) => {
        const isActive = s.id === active;
        const isDone = done.includes(s.id);
        return (
          <React.Fragment key={s.id}>
            <button data-testid={`step-${s.id}`} onClick={() => onSelect?.(s.id)}
              className="flex items-center gap-2.5 shrink-0 group">
              <span className={`grid place-items-center w-9 h-9 rounded-full text-sm font-semibold border-2 transition-all
                ${isActive ? "bg-[#29abe2] border-[#29abe2] text-white shadow-lg shadow-[#29abe2]/30 scale-110"
                  : isDone ? "bg-[#0f2557] border-[#0f2557] text-white dark:bg-[#29abe2] dark:border-[#29abe2]"
                  : "bg-card border-border text-muted-foreground group-hover:border-[#29abe2]/50"}`}>
                {isDone && !isActive ? "✓" : s.n}
              </span>
              <span className="hidden md:block text-left">
                <div className={`text-sm font-semibold ${isActive ? "text-foreground" : "text-muted-foreground"}`}>{s.label}</div>
                <div className="text-[10px] text-muted-foreground">{s.desc}</div>
              </span>
            </button>
            {i < STEPS.length - 1 && <div className={`h-0.5 w-6 lg:w-10 mx-1 rounded ${isDone ? "bg-[#29abe2]" : "bg-border"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
